export enum DocumentTypeEnum {
  ALL = 'ALL',
  SHARED = 'SHARED',
  PRODUCT = 'PRODUCT',
  CONFIGURATION = 'CONFIGURATION',
  RULE = 'RULE',
  BUSINESS_DATA = 'BUSINESS_DATA'
}
